import React, { useContext } from "react";
import { Routes, Route, Outlet } from "react-router-dom";
import { useSelector } from "react-redux";
/// Css
import "./../index.css";
import "./../chart.css";
import "./../step.css";

/// Layout
import Nav from "../layouts/nav";
import Footer from "../layouts/Footer";

import { ThemeContext } from "../../context/ThemeContext";
//Scroll To Top
import ScrollToTop from "../layouts/ScrollToTop";

/// Dashboard
import Home from "../pages/dashboard/Home";
import Dashboard2 from "../pages/dashboard/Dashboard2";
import Dashboard3 from "../pages/dashboard/Dashboard3";
import EmptyPage from "../pages/dashboard/EmptyPage";

//Event
import EventManagement from "../pages/dashboard/EventManagement";

//Course
import AllCourses from "../pages/courses/AllCourses";
import AddCourses from "../pages/courses/AddCourses";
import EditCourses from "../pages/courses/EditCourses";
import AboutCourses from "../pages/courses/AboutCourses";

//Department
import AllDepartments from "../pages/departments/AllDepartments";
import AddDepartments from "../pages/departments/AddDepartments";
import EditDepartments from "../pages/departments/EditDepartments";

//Staff
import AllStaff from "../pages/staff/AllStaff";
import AddStaff from "../pages/staff/AddStaff";
import EditStaff from "../pages/staff/EditStaff";
import ProfileStaff from "../pages/staff/ProfileStaff";

//holidays
import AllHoliday from "../pages/holidays/AllHoliday";
import AddHoliday from "../pages/holidays/AddHoliday";
import EditHoliday from "../pages/holidays/EditHoliday";
import HolidayEvent from "../pages/holidays/HolidayEvent";

//Fees
import FeeCollection from "../pages/fees/FeeCollection";
import AddFees from "../pages/fees/AddFees";
import FeesReceipt from "../pages/fees/FeesReceipt";

/// App
import AppProfile from "../pages/apps/AppProfile";
import PostDetails from "../pages/apps/PostDetails";
import EditProfile from "../pages/apps/EditProfile";
import Calendar from "../pages/apps/Calendar/Calendar";
import Compose from "../pages/email/Compose/Compose";
import Inbox from "../pages/email/Inbox/Inbox";
import Read from "../pages/email/Read";

//CMS
import Content from "../pages/cms/Content";
import Menu from "../pages/cms/Menu";
import EmailTemplate from "../pages/cms/EmailTemplate";
import CmsBlog from "../pages/cms/Blog";
import ContentAdd from "../pages/cms/ContentAdd";
import AddMail from "../pages/cms/AddMail";
import AddBlog from "../pages/cms/AddBlog";
import BlogCategory from "../pages/cms/BlogCategory";

/// Product List
import ProductGrid from "../pages/ecommerce/ProductGrid/ProductGrid";
import ProductList from "../pages/ecommerce/ProductList/ProductList";
import ProductDetail from "../pages/ecommerce/ProductGrid/ProductDetail";
import Checkout from "../pages/ecommerce/Checkout";
import EcomCustomers from "../pages/ecommerce/Customers";
import Invoice from "../pages/ecommerce/Invoice";
import ProductOrder from "../pages/ecommerce/ProductOrder";

/// Charts
import RechartJs from "../pages/charts/rechart";
import ChartJs from "../pages/charts/Chartjs";
import SparklineChart from "../pages/charts/Sparkline";
import ApexChart from "../pages/charts/apexcharts";

/// Bootstrap
import UiAlert from "../pages/bootstrap/Alert";
import UiAccordion from "../pages/bootstrap/Accordion";
import UiBadge from "../pages/bootstrap/Badge";
import UiButton from "../pages/bootstrap/Button";
import UiModal from "../pages/bootstrap/Modal";
import UiButtonGroup from "../pages/bootstrap/ButtonGroup";
import UiListGroup from "../pages/bootstrap/ListGroup";
import MediaObject from "../pages/bootstrap/MediaObject";
import UiCards from "../pages/bootstrap/Cards";
import UiCarousel from "../pages/bootstrap/Carousel";
import UiDropDown from "../pages/bootstrap/DropDown";
import UiPopOver from "../pages/bootstrap/PopOver";
import UiProgressBar from "../pages/bootstrap/ProgressBar";
import UiTab from "../pages/bootstrap/Tab";
import UiPagination from "../pages/bootstrap/Pagination";
import UiGrid from "../pages/bootstrap/Grid";
import UiTypography from "../pages/bootstrap/Typography";

/// Plugins
import Select2 from "../pages/plugins/Select2/Select2";
import MainSweetAlert from "../pages/plugins/SweetAlert";
import Toastr from "../pages/plugins/Toastr";
import Lightgallery from "../pages/plugins/Lightgallery";

/// Widget
import WidgetCard from "../pages/widget/WidgetCard";
import WidgetChart from "../pages/widget/WidgetChart";
import WidgetList from "../pages/widget/WidgetList";

/// Table
import DataTable from "../pages/table/DataTable";
import BootstrapTable from "../pages/table/BootstrapTable";
import SortingTable from "../pages/table/SortingTable/SortingTable";
import FilteringTable from "../pages/table/FilteringTable/FilteringTable";

/// Form
import Element from "../pages/forms/Element/Element";
import Wizard from "../pages/forms/Wizard/Wizard";
import Pickers from "../pages/forms/Pickers/Pickers";
import CkEditor from "../pages/forms/CkEditor/CkEditor";
import FormValidation from "../pages/forms/FormValidation/FormValidation";

/// Pages
import LockScreen from "../pages/error/LockScreen";
import Error400 from "../pages/error/Error400";
import Error403 from "../pages/error/Error403";
import Error404 from "../pages/error/Error404";
import Error500 from "../pages/error/Error500";
import Error503 from "../pages/error/Error503";

//security users
import Users from "../pages/security/Users";
import Roles from "../pages/security/Roles";
import Permissions from "../pages/security/Permissions";
import PlayerAttendance from "../pages/palyer-pages/PlayerAttendance";
import PlayerPaymentHistory from "../pages/palyer-pages/PlayerPaymentHistory";
import UserProfile from "../pages/profile/useProfile";

const PlayerDashboard = () => {
  const allroutes = [
    { url: "attendance", component: <PlayerAttendance /> },
    { url: "user-profile", component: <UserProfile /> },
    { url: "payment-history", component: <PlayerPaymentHistory /> },
    { url: "empty", component: <EmptyPage /> },
  ];

  function NotFound() {
    const url = allroutes.map((route) => route.url);
    let path = window.location.pathname;
    path = path.split("/");
    path = path[path.length - 1];

    if (url.indexOf(path) <= 0) {
      return <Error404 />;
    }
  }

  return (
    <>
      <Routes>
        <Route path="/page-lock-screen" element={<LockScreen />} />
        <Route path="/page-error-400" element={<Error400 />} />
        <Route path="/page-error-403" element={<Error403 />} />
        <Route path="/page-error-404" element={<Error404 />} />
        <Route path="/page-error-500" element={<Error500 />} />
        <Route path="/page-error-503" element={<Error503 />} />
        <Route element={<MainLayout />}>
          {allroutes.map((data, i) => (
            <Route
              key={i}
              exact
              path={`${data.url}`}
              element={data.component}
            />
          ))}
        </Route>
        <Route path="*" element={<NotFound />} />
      </Routes>
      <ScrollToTop />
    </>
  );
};

function MainLayout() {
  const { sidebariconHover } = useContext(ThemeContext);
  const sideMenu = useSelector((state) => state.sideMenu);
  return (
    <>
      <div
        id="main-wrapper"
        className={`show  ${sidebariconHover ? "iconhover-toggle" : ""} ${
          sideMenu ? "menu-toggle" : ""
        }`}
      >
        <Nav />
        <div className="content-body">
          <div
            className="container-fluid"
            style={{ minHeight: window.screen.height - 45 }}
          >
            <Outlet />
          </div>
        </div>
        <Footer />
      </div>
    </>
  );
}

export default PlayerDashboard;
